<template>
  <section>
    <navbar-public></navbar-public>

    <section class="ew-smaller-container ew-mb">
      <h1 class="ew-section-header ew-section-header--no-margin">Servicios</h1>

      <div class="ew-service-card" v-for="s in services" :key="s.title">
        <div class="ew-service-card__text">
          <h2 class="ew-service-card__title">{{ s.title }}</h2>
          <p v-for="(p, i) in s.paragraphs" :key="i">{{ p }}</p>
        </div>
        <img class="ew-service-card__image" :src="s.image" alt="">
      </div>

      <router-link class="ew-btn-primary" to="/signup">¡Regístrate!</router-link>
    </section>

    <footer-public></footer-public>
    <call-float-button></call-float-button>
  </section>
</template>

<script>
import NavbarPublic from './Header/NavbarPublic'
import FooterPublic from './Header/FooterPublic'
import CallFloatButton from './Header/CallFloatButton'

export default {
  name: 'Services',
  data () {
    return {
      services: [
        {
          title: 'Paquetería y Mensajería Nacional',
          paragraphs: ['Envío de documentos y paquetes, puerta a puerta con servicio terrestre o al día siguiente hábil. Servicio con cobertura hacia toda la República Mexicana.'],
          image: require('@/assets/images/13.- Servicios-01.png')
        },
        {
          title: 'Paquetería y Mensajería Internacional',
          paragraphs: ['Envío de documentos y paquetes hacia más de 220 países, puerta a puerta al siguiente día hábil posible, de acuerdo a la cobertura.'],
          image: require('@/assets/images/13.- Servicios-02.png')
        },
        {
          title: 'Consolidado LTL',
          paragraphs: [
            'Tu carga viaja en tarimas individuales que garantizan máxima seguridad y facilidad de manejo.',
            'Rutas terrestres que conectan los principales puntos del país, con recolecciones y entregas en tiempos preestablecidos.'
          ],
          image: require('@/assets/images/13.- Servicios-03.png')
        }
      ]
    }
  },
  watch: {},
  methods: {},
  computed: {},
  created () {},
  components: {
    'navbar-public': NavbarPublic,
    'footer-public': FooterPublic,
    'call-float-button': CallFloatButton
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 760px; margin: 0 auto; }
.ew-mb { margin-bottom: 5rem; }
.ew-btn-primary { @include ew-btn-primary; }

.ew-service-card {
  @include ew-card;
  padding: 1.5rem 1.75rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;

  &__text {
    flex: 1 1 320px;
    font-family: var(--app-font);
    color: var(--app-navy-secondary);
    line-height: 1.6;
  }

  &__title {
    font-family: var(--app-font);
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--app-navy);
    margin-bottom: 0.5rem;
  }

  &__image {
    max-width: 130px;
    flex-shrink: 0;
    margin-left: auto;
  }
}

@media (max-width: 480px) {
  .ew-service-card__image { margin: 0 auto; }
}
</style>



// WEBPACK FOOTER //
// src/components/Services.vue